import { handleActions } from 'redux-actions';

export default handleActions(
	{
		FETCH_ACCOMMODATION_DATA_FULFILLED: (state, action) => ({
			...state,
			checkInTime: action.payload.checkInTime,
			checkOutTime: action.payload.checkOutTime,
			features: action.payload.features,
			categoryList: action.payload.categoryList,
			categoryData: action.payload.categoryData,
			roomList: action.payload.roomList,
			roomData: action.payload.roomData,
		}),
	},
	{
		checkInTime: {
			ampm: 'pm',
			time: '3:00',
		},
		checkOutTime: {
			ampm: 'pm',
			time: '3:00',
		},
		features: [],
		categoryList: [],
		categoryData: {},
		roomList: [],
		roomData: {},
	},
);



// WEBPACK FOOTER //
// ./src/reducers/accommodation.js